<p-confirmdialog />

<div class="space-y-6">
  <!--
    Jamlanma kartochkalar — JORIY QOLDIQ bo'yicha (sotilgan tovar bo'yicha emas).
    Filtr ro'yxat bilan bir xil: qidiruv + do'kon(lar).

    Uch raqam ham BITTA valyutadagi mahsulotlarni jamlaydi — turli valyutadagi
    tannarx/sotuv qiymatlarini qo'shib bo'lmaydi. Valyuta tanlagichi faqat 2+
    valyuta yoqilganda ko'rinadi.
  -->
  @if (currencySvc.hasMultipleCurrencies()) {
    <div class="flex items-center gap-2">
      <label for="summary-currency" class="text-xs font-medium text-gray-500 dark:text-gray-400">
        {{ 'PRODUCTS.FORM.SELL_CURRENCY' | translate }}
      </label>
      <p-select
        inputId="summary-currency"
        [options]="currencySvc.currencyOptions()"
        optionLabel="label"
        optionValue="value"
        [ngModel]="summaryCurrency()"
        (ngModelChange)="onSummaryCurrencyChange($event)"
        appendTo="body"
        size="small"
        class="w-full sm:w-44"
      />
    </div>
  }

  <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
    <!-- Tannarx -->
    <div
      class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4"
    >
      <div class="flex items-center gap-2 text-sm text-gray-500">
        <i class="pi pi-shopping-bag text-xs"></i>
        {{ 'PRODUCTS.SUMMARY.PURCHASE_VALUE' | translate }}
      </div>
      @if (summaryLoading() && !summary()) {
        <div class="mt-2 h-7 w-32 rounded bg-gray-100 dark:bg-gray-800 animate-pulse"></div>
      } @else {
        <div class="text-2xl font-bold text-gray-900 dark:text-gray-100 mt-1">
          {{ summary()?.totalPurchaseValue ?? 0 | money: summaryCurrency() }}
        </div>
        <!--
          Tannarxi 0 bo'lgan tovar tannarxga qo'shilmaydi, lekin sotuv qiymatiga
          to'liq kiradi — foyda oshib ko'rinadi. Shu sababni ochiq aytamiz.
        -->
        @if ((summary()?.noCostQuantity ?? 0) > 0) {
          <div class="text-xs text-amber-600 dark:text-amber-500 mt-1 flex items-start gap-1">
            <i class="pi pi-exclamation-triangle text-[10px] mt-0.5"></i>
            <span>
              {{
                'PRODUCTS.SUMMARY.NO_COST_WARN' | translate: { qty: summary()?.noCostQuantity ?? 0 }
              }}
            </span>
          </div>
        }
      }
    </div>

    <!-- Sotuv narxi -->
    <div
      class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4"
    >
      <div class="flex items-center gap-2 text-sm text-gray-500">
        <i class="pi pi-tag text-xs"></i>
        {{ 'PRODUCTS.SUMMARY.SELL_VALUE' | translate }}
      </div>
      @if (summaryLoading() && !summary()) {
        <div class="mt-2 h-7 w-32 rounded bg-gray-100 dark:bg-gray-800 animate-pulse"></div>
      } @else {
        <div class="text-2xl font-bold text-gray-900 dark:text-gray-100 mt-1">
          {{ summary()?.totalSellValue ?? 0 | money: summaryCurrency() }}
        </div>
      }
    </div>

    <!-- Sof foyda (qoldiq sotilsa) -->
    <div
      class="rounded-xl border-2 p-4"
      [class.border-green-300]="(summary()?.potentialProfit ?? 0) >= 0"
      [class.bg-green-50]="(summary()?.potentialProfit ?? 0) >= 0"
      [class.dark:bg-green-950]="(summary()?.potentialProfit ?? 0) >= 0"
      [class.border-red-300]="(summary()?.potentialProfit ?? 0) < 0"
      [class.bg-red-50]="(summary()?.potentialProfit ?? 0) < 0"
      [class.dark:bg-red-950]="(summary()?.potentialProfit ?? 0) < 0"
    >
      <div class="flex justify-between">
        <div
          class="flex items-center justify-between gap-2 text-sm text-gray-500 dark:text-gray-400"
        >
          <i class="pi pi-chart-line text-xs"></i>
          {{ 'PRODUCTS.SUMMARY.PROFIT' | translate }}
        </div>
        <div class="text-xs text-gray-400 mt-1">
          {{ 'PRODUCTS.SUMMARY.PROFIT_HINT' | translate }}
        </div>
      </div>
      @if (summaryLoading() && !summary()) {
        <div class="mt-2 h-7 w-32 rounded bg-gray-200 dark:bg-gray-800 animate-pulse"></div>
      } @else {
        <div
          class="text-2xl font-bold mt-1"
          [class.text-green-700]="(summary()?.potentialProfit ?? 0) >= 0"
          [class.dark:text-green-400]="(summary()?.potentialProfit ?? 0) >= 0"
          [class.text-red-700]="(summary()?.potentialProfit ?? 0) < 0"
          [class.dark:text-red-400]="(summary()?.potentialProfit ?? 0) < 0"
        >
          {{ summary()?.potentialProfit ?? 0 | money: summaryCurrency() }}
        </div>
        <!--
          Kelish va sotuv valyutasi har xil bo'lgan mol (`$70` ga olib so'mda
          sotish): tannarxi bir daftarda, sotuvi boshqasida. Narxlar o'girilmaydi
          (I4), shuning uchun bu ko'rsatkich ular uchun to'liq emas.
        -->
        @if ((summary()?.mixedCurrencyQuantity ?? 0) > 0) {
          <div class="text-xs text-amber-600 dark:text-amber-500 mt-1 flex items-start gap-1">
            <i class="pi pi-exclamation-triangle text-[10px] mt-0.5"></i>
            <span>
              {{
                'PRODUCTS.SUMMARY.MIXED_CURRENCY_WARN'
                  | translate: { qty: summary()?.mixedCurrencyQuantity ?? 0 }
              }}
            </span>
          </div>
        }
      }
    </div>
  </div>

  <!-- Search panel -->
  <div class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4">
    <div class="flex flex-col sm:flex-row gap-3">
      <div class="flex gap-2 flex-1">
        <!--
          `[value]` + `(input)`, `[(ngModel)]` emas: Enter bosilganda faqat INPUT
          tozalanadi, ro'yxat esa o'sha so'rov natijasi bo'lib qolishi kerak
          (`searchQuery` saqlanadi). Ikkalasi bitta o'zgaruvchi bo'lsa bunday
          ajratib bo'lmasdi.
        -->
        <input
          pInputText
          [placeholder]="'PRODUCTS.SEARCH_PLACEHOLDER' | translate"
          class="flex-1"
          [value]="searchText"
          (input)="onSearchInput($any($event.target).value)"
          (keydown.enter)="onSearchEnter()"
        />
        <app-barcode-scanner (barcodeDetected)="onSearchBarcodeDetected($event)" />
      </div>

      <!-- Bitta do'konda filtr yashiriladi: "hammasi" bilan bir xil natija beradi. -->
      @if (storeFilterVisible()) {
        <p-multiselect
          [options]="stores()"
          optionLabel="name"
          optionValue="id"
          [placeholder]="'PRODUCTS.STORE_FILTER' | translate"
          [showClear]="true"
          [(ngModel)]="filterStoreIds"
          (onChange)="onSearch()"
          appendTo="body"
          display="chip"
          class="w-full sm:w-56"
        />
      }

      <p-button
        icon="pi pi-search"
        [label]="'PRODUCTS.SEARCH_BTN' | translate"
        severity="secondary"
        (onClick)="onSearch()"
      />
      <!-- Ko'chirish do'kondan do'konga — bitta do'konda amalning ma'nosi yo'q. -->
      @if (canTransfer()) {
        <p-button
          [label]="'PRODUCTS.TRANSFER' | translate"
          icon="pi pi-arrow-right-arrow-left"
          severity="secondary"
          [outlined]="true"
          (onClick)="openTransfer()"
        />
      }
      <p-button
        [label]="'PRODUCTS.CREATE' | translate"
        icon="pi pi-plus"
        (onClick)="openCreate()"
      />
    </div>
  </div>

  <!-- Table -->
  <div
    class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 overflow-hidden"
  >
    <div class="overflow-x-auto">
      <p-table
        [value]="products()"
        [lazy]="true"
        (onLazyLoad)="loadProducts($event)"
        [totalRecords]="totalCount()"
        [paginator]="true"
        [rows]="pageSize"
        [rowsPerPageOptions]="[20, 50, 100]"
        [loading]="loading()"
        [showCurrentPageReport]="false"
        [showFirstLastIcon]="false"
        styleClass="p-datatable-gridlines"
        [tableStyle]="{ 'min-width': '60rem' }"
      >
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 3rem">#</th>
            @if (allowProductImages()) {
              <th style="width: 3.5rem"></th>
            }
            <th pSortableColumn="name">
              {{ 'PRODUCTS.TABLE.NAME' | translate }} <p-sortIcon field="name" />
            </th>
            <th>{{ 'PRODUCTS.TABLE.BRAND' | translate }}</th>
            <th>{{ 'PRODUCTS.TABLE.BARCODE' | translate }}</th>
            <th pSortableColumn="purchasePrice">
              {{ 'PRODUCTS.TABLE.PURCHASE_PRICE' | translate }}
              <p-sortIcon field="purchasePrice" />
            </th>
            <th pSortableColumn="sellPrice">
              {{ 'PRODUCTS.TABLE.PRICE' | translate }} <p-sortIcon field="sellPrice" />
            </th>
            <th>{{ 'PRODUCTS.TABLE.DISCOUNT' | translate }}</th>
            <th pSortableColumn="stocks">
              {{ 'PRODUCTS.TABLE.STOCK' | translate }} <p-sortIcon field="stocks" />
            </th>
            <th>{{ 'PRODUCTS.TABLE.CATEGORY' | translate }}</th>
            <th>{{ 'PRODUCTS.TABLE.UNIT' | translate }}</th>
            <th style="width: 8rem">{{ 'PRODUCTS.TABLE.ACTIONS' | translate }}</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
          <tr>
            <td class="text-gray-500 dark:text-gray-400 text-sm">{{ rowIndex + 1 }}</td>
            @if (allowProductImages()) {
              <td>
                @if (product.imageUrl) {
                  <img
                    [src]="product.imageUrl"
                    [alt]="product.name"
                    class="w-9 h-9 rounded-lg object-cover border border-gray-200 dark:border-gray-700"
                  />
                } @else {
                  <div
                    class="w-9 h-9 rounded-lg bg-gray-100 dark:bg-gray-800 flex items-center justify-center"
                  >
                    <i class="pi pi-box text-gray-400 text-sm"></i>
                  </div>
                }
              </td>
            }
            <td>
              <button
                type="button"
                (click)="openDetail(product)"
                class="font-medium text-left text-indigo-600 hover:text-indigo-700 dark:text-indigo-400 dark:hover:text-indigo-300 hover:underline transition-colors"
              >
                {{ product.name }}
              </button>
            </td>
            <td class="text-gray-600 dark:text-gray-400">{{ product.brand || '—' }}</td>
            <td>
              <div class="flex items-center gap-2 flex-wrap">
                <code class="text-xs bg-gray-100 dark:bg-gray-800 px-2 py-0.5 rounded font-mono">
                  {{ product.barcode }}
                </code>
                @if (product.isWeight) {
                  <span
                    class="text-xs bg-emerald-50 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-300 px-2 py-0.5 rounded font-mono font-semibold"
                  >
                    {{ product.productNumber.toString().padStart(5, '0') }}
                  </span>
                }
              </div>
            </td>
            <td class="text-gray-600 dark:text-gray-400">
              {{ product.purchasePrice | money: product.purchaseCurrency }}
            </td>
            <td class="font-semibold text-gray-900 dark:text-gray-100">
              {{ product.sellPrice | money: product.sellCurrency }}
            </td>
            <td>
              @if (product.discount > 0) {
                <p-tag value="{{ product.discount }}%" severity="success" />
              } @else {
                <span class="text-gray-400 dark:text-gray-600">—</span>
              }
            </td>
            <td>
              @if (product.stocks <= 0) {
                <p-tag [value]="'PRODUCTS.STATUS.OUT_OF_STOCK' | translate" severity="danger" />
              } @else if (product.stocks < 10) {
                <span class="inline-flex items-center gap-1 text-orange-600 font-semibold">
                  <i class="pi pi-exclamation-triangle text-xs"></i>
                  {{ product.stocks }}
                </span>
              } @else {
                <span class="text-gray-900 dark:text-gray-100 font-medium">{{
                  product.stocks
                }}</span>
              }
            </td>
            <td class="text-gray-600 dark:text-gray-400">{{ product.categoryName || '—' }}</td>
            <td class="text-gray-600 dark:text-gray-400">{{ product.unitOfMeasureName || '—' }}</td>
            <td>
              <div class="flex items-center gap-1">
                <p-button
                  icon="pi pi-eye"
                  [text]="true"
                  severity="secondary"
                  size="small"
                  (onClick)="openDetail(product)"
                  [pTooltip]="'PRODUCTS.DETAIL.VIEW_TOOLTIP' | translate"
                />
                <p-button
                  icon="pi pi-plus-circle"
                  [text]="true"
                  severity="success"
                  size="small"
                  (onClick)="openStock(product)"
                  [pTooltip]="'PRODUCTS.ADD_STOCK' | translate"
                />
                <p-button
                  icon="pi pi-pencil"
                  [text]="true"
                  severity="secondary"
                  size="small"
                  (onClick)="openEdit(product)"
                  [pTooltip]="'PRODUCTS.EDIT_TOOLTIP' | translate"
                />
                <p-button
                  icon="pi pi-trash"
                  [text]="true"
                  severity="danger"
                  size="small"
                  (onClick)="confirmDelete(product)"
                  [pTooltip]="'PRODUCTS.DELETE_TOOLTIP' | translate"
                />
              </div>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="11" class="text-center py-12 text-gray-500 dark:text-gray-400">
              <div class="flex flex-col items-center gap-2">
                <i class="pi pi-inbox text-4xl text-gray-300"></i>
                <span>{{ 'PRODUCTS.EMPTY' | translate }}</span>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<!-- ══ Mahsulot detali (view) ══ -->
<p-dialog
  [(visible)]="detailVisible"
  [modal]="true"
  [header]="detailProduct?.name ?? ''"
  [style]="{ width: 'min(56rem, 95vw)' }"
  [contentStyle]="{ 'max-height': '82vh', 'overflow-y': 'auto' }"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeDetail()"
>
  @if (detailProduct) {
    <app-product-detail
      [product]="detailProduct"
      [storeId]="filterStoreIds.length ? filterStoreIds[0] : null"
      [storeName]="filterStoreIds.length ? getStoreName(filterStoreIds[0]) : null"
      mode="view"
      (requestEdit)="openEdit(detailProduct); detailVisible = false"
    />
  }

  <ng-template pTemplate="footer">
    <p-button
      [label]="'COMMON.CLOSE' | translate"
      severity="secondary"
      [outlined]="true"
      (onClick)="closeDetail()"
    />
  </ng-template>
</p-dialog>

<!-- Transfer Dialog -->
<p-dialog
  [header]="'PRODUCTS.TRANSFER_DIALOG.TITLE' | translate"
  [(visible)]="transferDialogVisible"
  [modal]="true"
  [style]="{ width: 'min(36rem, 95vw)' }"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeTransfer()"
>
  <div class="flex flex-col gap-4 pt-2">
    <!-- 1. From / To stores — yonma-yon -->
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <div class="flex flex-col gap-1">
        <label for="" class="text-sm font-medium text-gray-700 dark:text-gray-300">
          {{ 'PRODUCTS.TRANSFER_DIALOG.FROM_STORE' | translate }}
          <span class="text-red-500">*</span>
        </label>
        <p-select
          [options]="stores()"
          optionLabel="name"
          optionValue="id"
          [placeholder]="'PRODUCTS.TRANSFER_DIALOG.SELECT_STORE' | translate"
          [ngModel]="transferForm.fromStoreId"
          (ngModelChange)="onTransferFromStoreChange($event)"
          appendTo="body"
          class="w-full"
        />
      </div>
      <div class="flex flex-col gap-1">
        <label for="" class="text-sm font-medium text-gray-700 dark:text-gray-300">
          {{ 'PRODUCTS.TRANSFER_DIALOG.TO_STORE' | translate }} <span class="text-red-500">*</span>
        </label>
        <p-select
          [options]="transferToStoreOptions()"
          optionLabel="name"
          optionValue="id"
          [placeholder]="
            transferFromStoreId()
              ? ('PRODUCTS.TRANSFER_DIALOG.SELECT_STORE' | translate)
              : ('PRODUCTS.FORM.SELECT_STORE_FIRST' | translate)
          "
          [disabled]="!transferFromStoreId()"
          [ngModel]="transferForm.toStoreId"
          (ngModelChange)="onTransferToStoreChange($event)"
          appendTo="body"
          class="w-full"
        />
      </div>
    </div>

    <!-- 2. Product — fromStore tanlangandan keyin, shu storedan -->
    <div class="flex flex-col gap-1">
      <label for="" class="text-sm font-medium text-gray-700 dark:text-gray-300">
        {{ 'PRODUCTS.TRANSFER_DIALOG.PRODUCT' | translate }} <span class="text-red-500">*</span>
      </label>
      <div class="flex gap-2">
        <p-select
          [options]="transferStoreProducts()"
          optionLabel="name"
          optionValue="id"
          [placeholder]="
            transferFromStoreId()
              ? ('PRODUCTS.TRANSFER_DIALOG.SELECT_PRODUCT' | translate)
              : ('PRODUCTS.FORM.SELECT_STORE_FIRST' | translate)
          "
          [filter]="true"
          filterBy="name,barcode"
          [loading]="transferStoreProductsLoading()"
          [virtualScroll]="true"
          [virtualScrollItemSize]="38"
          [disabled]="!transferFromStoreId()"
          [ngModel]="transferForm.productId"
          (ngModelChange)="onTransferProductChange($event)"
          appendTo="body"
          class="flex-1"
        />
        <app-barcode-scanner (barcodeDetected)="onTransferBarcodeDetected($event)" />
      </div>
    </div>

    <!-- 3. Variant (agar variantli mahsulot tanlansa) -->
    @if (transferVariants().length > 0) {
      <div class="flex flex-col gap-1">
        <label for="" class="text-sm font-medium text-gray-700 dark:text-gray-300">
          {{ 'PRODUCTS.STOCK_DIALOG.VARIANT' | translate }} <span class="text-red-500">*</span>
        </label>
        <div
          class="flex flex-col gap-1 max-h-40 overflow-y-auto border border-gray-200 dark:border-gray-700 rounded-lg p-1"
        >
          @for (v of transferVariants(); track v.id) {
            <button
              type="button"
              (click)="transferForm.productVariantId = v.id"
              class="w-full flex items-center justify-between px-3 py-2 text-sm transition-colors text-left border-b border-gray-100 dark:border-gray-800 last:border-0"
              [ngClass]="
                transferForm.productVariantId === v.id
                  ? 'bg-indigo-50 dark:bg-indigo-900/20 text-indigo-700 dark:text-indigo-300'
                  : 'hover:bg-gray-50 dark:hover:bg-gray-800 text-gray-700 dark:text-gray-300'
              "
            >
              <span class="font-medium">{{ variantLabel(v) }}</span>
              <span
                class="text-xs ml-2 shrink-0"
                [ngClass]="(v.stock ?? 0) <= 0 ? 'text-red-400' : 'text-gray-400'"
              >
                {{ v.stock ?? 0 }} {{ 'PRODUCTS.DETAIL.PCS' | translate }}
              </span>
            </button>
          }
        </div>
      </div>
    }

    <div class="flex flex-col gap-1">
      <label for="" class="text-sm font-medium text-gray-700 dark:text-gray-300">
        {{ 'PRODUCTS.TRANSFER_DIALOG.QUANTITY' | translate }} <span class="text-red-500">*</span>
      </label>
      <p-inputnumber placeholder="0" [min]="1" [(ngModel)]="transferForm.quantity" class="w-full" />
    </div>

    <div class="flex flex-col gap-1">
      <label for="" class="text-sm font-medium text-gray-700 dark:text-gray-300">{{
        'PRODUCTS.TRANSFER_DIALOG.DESCRIPTION' | translate
      }}</label>
      <input
        pInputText
        [placeholder]="'PRODUCTS.TRANSFER_DIALOG.DESC_HINT' | translate"
        [(ngModel)]="transferForm.description"
      />
    </div>
  </div>

  <ng-template pTemplate="footer">
    <p-button
      [label]="'PRODUCTS.TRANSFER_DIALOG.CANCEL' | translate"
      severity="secondary"
      [outlined]="true"
      (onClick)="closeTransfer()"
      [disabled]="transferSaving()"
    />
    <p-button
      [label]="'PRODUCTS.TRANSFER_DIALOG.SAVE' | translate"
      icon="pi pi-arrow-right-arrow-left"
      (onClick)="saveTransfer()"
      [loading]="transferSaving()"
    />
  </ng-template>
</p-dialog>

<!-- Add Stock Dialog -->
<p-dialog
  [header]="'PRODUCTS.STOCK_DIALOG.TITLE' | translate"
  [(visible)]="stockDialogVisible"
  [modal]="true"
  [style]="{ width: 'min(36rem, 95vw)' }"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeStock()"
>
  <div class="flex flex-col gap-4 pt-2">
    <div class="flex flex-col gap-1">
      <label for="" class="text-sm font-medium text-gray-700 dark:text-gray-300">
        {{ 'PRODUCTS.STOCK_DIALOG.PRODUCT' | translate }} <span class="text-red-500">*</span>
      </label>
      <div class="flex gap-2">
        <p-select
          [options]="allProducts()"
          optionLabel="name"
          optionValue="id"
          [placeholder]="'PRODUCTS.STOCK_DIALOG.SELECT_PRODUCT' | translate"
          [filter]="true"
          filterBy="name,barcode"
          [loading]="allProductsLoading()"
          [virtualScroll]="true"
          [virtualScrollItemSize]="38"
          [ngModel]="stockForm.productId"
          (ngModelChange)="onStockProductChange($event)"
          appendTo="body"
          class="flex-1"
        />
        <app-barcode-scanner (barcodeDetected)="onStockBarcodeDetected($event)" />
      </div>
    </div>

    <!-- Variant tanlash (mahsulot variantli bo'lsa) -->
    @if (stockVariantsLoading()) {
      <div class="flex items-center gap-2 text-sm text-gray-400 py-1">
        <i class="pi pi-spin pi-spinner text-xs"></i>
        {{ 'PRODUCTS.FORM.VARIANTS_LOADING' | translate }}
      </div>
    } @else if (stockVariants().length > 0) {
      <div class="flex flex-col gap-1">
        <label for="" class="text-sm font-medium text-gray-700 dark:text-gray-300">
          {{ 'PRODUCTS.STOCK_DIALOG.VARIANT' | translate }} <span class="text-red-500">*</span>
        </label>
        <div
          class="rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden max-h-44 overflow-y-auto"
        >
          @for (v of stockVariants(); track v.id) {
            <button
              type="button"
              (click)="stockForm.productVariantId = v.id"
              class="w-full flex items-center justify-between px-3 py-2 text-sm transition-colors text-left border-b border-gray-100 dark:border-gray-800 last:border-0"
              [ngClass]="
                stockForm.productVariantId === v.id
                  ? 'bg-indigo-50 dark:bg-indigo-900/20 text-indigo-700 dark:text-indigo-300'
                  : 'hover:bg-gray-50 dark:hover:bg-gray-800 text-gray-700 dark:text-gray-300'
              "
            >
              <span class="font-medium">{{ variantLabel(v) }}</span>
              <span
                class="text-xs ml-2 shrink-0"
                [ngClass]="(v.stock ?? 0) <= 0 ? 'text-red-400' : 'text-gray-400'"
              >
                {{ v.stock ?? 0 }} {{ 'PRODUCTS.DETAIL.PCS' | translate }}
              </span>
            </button>
          }
        </div>
      </div>
    }

    <!-- Mahsulotga mos do'kon bitta bo'lsa o'zi qo'yiladi va maydon ko'rinmaydi. -->
    @if (stockStore.visible()) {
      <div class="flex flex-col gap-1">
        <label for="" class="text-sm font-medium text-gray-700 dark:text-gray-300">
          {{ 'PRODUCTS.STOCK_DIALOG.STORE' | translate }} <span class="text-red-500">*</span>
        </label>
        <p-select
          [options]="filteredStockStores()"
          optionLabel="name"
          optionValue="id"
          [placeholder]="'PRODUCTS.STOCK_DIALOG.SELECT_STORE' | translate"
          [ngModel]="stockForm.storeId"
          (ngModelChange)="onStockStoreChange($event)"
          [disabled]="!stockProductId()"
          appendTo="body"
          class="w-full"
        />
      </div>
    }

    <div class="flex flex-col gap-1">
      <label for="" class="text-sm font-medium text-gray-700 dark:text-gray-300">
        {{ 'PRODUCTS.STOCK_DIALOG.QUANTITY' | translate }} <span class="text-red-500">*</span>
      </label>
      <p-inputnumber placeholder="0" [min]="1" [(ngModel)]="stockForm.quantity" class="w-full" />
    </div>

    <!--
      Pul maydonlari ATAYLAB yo'q. Bu dialog faqat OMBOR qoldig'ini oshiradi —
      kassa, qarz va kirim hujjati tegilmaydi. Ikkisini bitta oynaga qo'shish
      qoldiq tuzatishni ham pul harakatiga aylantirib, hisobni chalkashtirardi.
      Pulli kirim "Kirim" (Purchases) bo'limidan kiritiladi.
    -->
    <p class="text-xs text-gray-500 dark:text-gray-400">
      {{ 'PRODUCTS.STOCK_DIALOG.NO_MONEY_HINT' | translate }}
    </p>

    <button
      type="button"
      (click)="stockAdvanced = !stockAdvanced"
      class="flex items-center gap-2 text-sm text-gray-500 hover:text-gray-700 dark:hover:text-gray-300 transition-colors w-fit"
    >
      <i [class]="stockAdvanced ? 'pi pi-chevron-up' : 'pi pi-chevron-down'" class="text-xs"></i>
      <span>{{
        stockAdvanced
          ? ('PRODUCTS.STOCK_DIALOG.ADVANCED_HIDE' | translate)
          : ('PRODUCTS.STOCK_DIALOG.ADVANCED_SHOW' | translate)
      }}</span>
    </button>

    @if (stockAdvanced) {
      <div class="flex flex-col gap-4 border-t border-gray-100 dark:border-gray-800 pt-4">
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div class="flex flex-col gap-1">
            <label for="" class="text-sm font-medium text-gray-700 dark:text-gray-300">
              {{ 'PRODUCTS.STOCK_DIALOG.PURCHASE_PRICE' | translate }}
            </label>
            <p-inputnumber
              placeholder="0"
              [min]="0"
              [minFractionDigits]="0"
              [maxFractionDigits]="currencySvc.priceInputDecimals(stockPurchaseCurrency())"
              [(ngModel)]="stockForm.newPurchasePrice"
              [useGrouping]="true"
              mode="decimal"
              class="w-full"
            />
          </div>
          <div class="flex flex-col gap-1">
            <label for="" class="text-sm font-medium text-gray-700 dark:text-gray-300">
              {{ 'PRODUCTS.STOCK_DIALOG.SELL_PRICE' | translate }}
            </label>
            <p-inputnumber
              placeholder="0"
              [min]="0"
              [minFractionDigits]="0"
              [maxFractionDigits]="currencySvc.priceInputDecimals(stockSellCurrency())"
              [(ngModel)]="stockForm.newSellPrice"
              [useGrouping]="true"
              mode="decimal"
              class="w-full"
            />
          </div>
        </div>
        <div class="flex flex-col gap-1">
          <label for="" class="text-sm font-medium text-gray-700 dark:text-gray-300">{{
            'PRODUCTS.STOCK_DIALOG.DESCRIPTION' | translate
          }}</label>
          <input
            pInputText
            [placeholder]="'PRODUCTS.STOCK_DIALOG.DESC_HINT' | translate"
            [(ngModel)]="stockForm.description"
          />
        </div>
      </div>
    }
  </div>

  <ng-template pTemplate="footer">
    <p-button
      [label]="'PRODUCTS.STOCK_DIALOG.CANCEL' | translate"
      severity="secondary"
      [outlined]="true"
      (onClick)="closeStock()"
      [disabled]="stockSaving()"
    />
    <p-button
      [label]="'PRODUCTS.STOCK_DIALOG.SAVE' | translate"
      icon="pi pi-plus-circle"
      (onClick)="saveStock()"
      [loading]="stockSaving()"
    />
  </ng-template>
</p-dialog>

<!-- Create / Edit Dialog -->
<p-dialog
  [header]="
    isEdit ? ('PRODUCTS.FORM.EDIT_TITLE' | translate) : ('PRODUCTS.FORM.CREATE_TITLE' | translate)
  "
  [(visible)]="dialogVisible"
  [modal]="true"
  [style]="{ width: 'min(44rem, 95vw)' }"
  [contentStyle]="{ 'max-height': '75vh', 'overflow-y': 'auto' }"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeDialog()"
>
  <div class="flex flex-col gap-4 pt-2">
    <!-- Image upload — faqat product_images moduli bo'lgan tarifda ko'rinadi -->
    @if (allowProductImages()) {
      <div class="flex flex-col gap-2">
        <span class="text-sm font-medium text-gray-700 dark:text-gray-300">
          {{ 'PRODUCTS.FORM.IMAGE' | translate }}
        </span>
        <div class="flex items-start gap-4">
          <div
            class="relative w-24 h-24 rounded-xl border-2 border-dashed border-gray-200 dark:border-gray-700 flex items-center justify-center flex-shrink-0 overflow-hidden bg-gray-50 dark:bg-gray-800"
          >
            @if (imageUploading()) {
              <div
                class="absolute inset-0 flex flex-col items-center justify-center gap-1 bg-black/40 z-10"
              >
                <i class="pi pi-spin pi-spinner text-white text-xl"></i>
                <span class="text-white text-xs">{{ 'PRODUCTS.FORM.UPLOADING' | translate }}</span>
              </div>
            }
            @if (imagePreview()) {
              <img [src]="imagePreview()!" alt="preview" class="w-full h-full object-cover" />
            } @else {
              <i class="pi pi-image text-3xl text-gray-300 dark:text-gray-600"></i>
            }
          </div>
          <div class="flex flex-col gap-2">
            <label
              for="pf-image"
              class="inline-flex items-center gap-2 cursor-pointer px-3 py-2 rounded-lg border border-gray-300 dark:border-gray-600 text-sm font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
              [class.opacity-50]="imageUploading()"
              [class.pointer-events-none]="imageUploading()"
            >
              <i class="pi pi-upload text-xs"></i>
              {{ 'PRODUCTS.FORM.UPLOAD_IMAGE' | translate }}
            </label>
            <input
              id="pf-image"
              type="file"
              accept="image/jpeg,image/png,image/webp"
              class="hidden"
              (change)="onImageSelected($event)"
            />
            <button
              type="button"
              (click)="openCamera()"
              [disabled]="imageUploading()"
              class="inline-flex items-center gap-2 px-3 py-2 rounded-lg border border-gray-300 dark:border-gray-600 text-sm font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <i class="pi pi-camera text-xs"></i>
              {{ 'PRODUCTS.FORM.TAKE_PHOTO' | translate }}
            </button>
            @if (imagePreview()) {
              <button
                type="button"
                (click)="removeImage()"
                [disabled]="imageUploading()"
                class="inline-flex items-center gap-2 px-3 py-2 rounded-lg border border-red-200 dark:border-red-800 text-sm font-medium text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <i class="pi pi-trash text-xs"></i>
                {{ 'PRODUCTS.FORM.REMOVE_IMAGE' | translate }}
              </button>
            }
            @if (imageError()) {
              <div
                class="flex items-start gap-1.5 rounded-lg bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 px-3 py-2"
              >
                <i class="pi pi-exclamation-circle text-red-500 text-sm mt-0.5 flex-shrink-0"></i>
                <span class="text-xs text-red-600 dark:text-red-400">{{ imageError() }}</span>
              </div>
            } @else {
              <!--
                Ilgari "max 5 MB" yozilardi va bu chalg'itardi: 5 MB — SIQILGANDAN
                keyingi chegara, foydalanuvchi esa uni tanlanadigan fayl chegarasi
                deb tushunardi. Rasm baribir 1200 px JPEG'ga siqiladi.
              -->
              <span class="text-xs text-gray-400 dark:text-gray-500">{{
                'PRODUCTS.FORM.IMAGE_HINT' | translate
              }}</span>
            }
          </div>
        </div>
      </div>

      @if (cameraOpen()) {
        <div class="fixed inset-0 z-[1200] flex items-center justify-center bg-black/70 p-4">
          <div class="w-full max-w-lg rounded-xl bg-white p-4 shadow-2xl dark:bg-gray-900">
            <div class="mb-3 flex items-center justify-between">
              <h3 class="text-base font-semibold text-gray-900 dark:text-gray-100">
                {{ 'PRODUCTS.CAMERA_DIALOG.TITLE' | translate }}
              </h3>
              <button
                type="button"
                (click)="stopCamera()"
                class="rounded-lg p-2 text-gray-500 hover:bg-gray-100 dark:hover:bg-gray-800"
                [attr.aria-label]="'PRODUCTS.CAMERA_DIALOG.CLOSE' | translate"
              >
                <i class="pi pi-times"></i>
              </button>
            </div>
            <video
              #cameraPreview
              autoplay
              playsinline
              class="max-h-[60vh] w-full rounded-lg bg-black object-contain"
            ></video>
            <div class="mt-4 flex justify-end gap-2">
              <button
                type="button"
                (click)="stopCamera()"
                class="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-800"
              >
                {{ 'PRODUCTS.CAMERA_DIALOG.CANCEL' | translate }}
              </button>
              <button
                type="button"
                (click)="capturePhoto()"
                class="rounded-lg bg-indigo-600 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-700"
              >
                <i class="pi pi-camera mr-2"></i>{{ 'PRODUCTS.CAMERA_DIALOG.CAPTURE' | translate }}
              </button>
            </div>
          </div>
        </div>
      }
    }

    <!--
      Store (create only) — must be selected first; filters category & unit.
      Bitta do'konli biznesda maydon ko'rinmaydi: u avtomatik tanlanadi.
    -->
    @if (!isEdit && formStore.visible()) {
      <div class="flex flex-col gap-1">
        <label for="pf-store" class="text-sm font-medium text-gray-700 dark:text-gray-300">
          {{ 'PRODUCTS.FORM.STORE' | translate }} <span class="text-red-500">*</span>
        </label>
        <p-select
          inputId="pf-store"
          [options]="stores()"
          optionLabel="name"
          optionValue="id"
          [placeholder]="'PRODUCTS.FORM.SELECT_STORE' | translate"
          [showClear]="stores().length > 1"
          [ngModel]="formStoreId()"
          (ngModelChange)="onFormStoreChange($event)"
          appendTo="body"
          class="w-full"
        />
      </div>
    }

    <!-- Name -->
    <div class="flex flex-col gap-1">
      <label for="pf-name" class="text-sm font-medium text-gray-700 dark:text-gray-300">
        {{ 'PRODUCTS.FORM.NAME' | translate }} <span class="text-red-500">*</span>
      </label>
      <input
        id="pf-name"
        pInputText
        [placeholder]="'PRODUCTS.FORM.NAME' | translate"
        [(ngModel)]="form.name"
      />
    </div>

    <div class="flex flex-col gap-1">
      <label for="pf-brand" class="text-sm font-medium text-gray-700 dark:text-gray-300">{{
        'PRODUCTS.FORM.BRAND' | translate
      }}</label
      ><input
        id="pf-brand"
        pInputText
        [placeholder]="'PRODUCTS.FORM.BRAND_PH' | translate"
        [(ngModel)]="form.brand"
      />
    </div>

    <!-- Barcode -->
    <div class="flex flex-col gap-1">
      <label for="pf-barcode" class="text-sm font-medium text-gray-700 dark:text-gray-300">
        {{ 'PRODUCTS.FORM.BARCODE' | translate }} <span class="text-red-500">*</span>
      </label>
      <div class="flex gap-2">
        <input
          id="pf-barcode"
          pInputText
          placeholder="0000000000000"
          [(ngModel)]="form.barcode"
          class="flex-1 min-w-0"
        />
        <app-barcode-scanner (barcodeDetected)="onFormBarcodeDetected($event)" />
        @if (!isEdit) {
          <p-button
            icon="pi pi-barcode"
            [label]="'PRODUCTS.FORM.GENERATE' | translate"
            severity="secondary"
            [outlined]="true"
            [loading]="generatingBarcode()"
            (onClick)="generateBarcode()"
          />
        }
      </div>
    </div>

    <!--
      Valyuta — narxlardan OLDIN turadi: u ikkala narxning ham o'lchov birligi (I1).
      Bitta valyuta yoqilgan bo'lsa tanlov ko'rsatilmaydi (ekran o'zgarmaydi).
    -->
    @if (currencySvc.hasMultipleCurrencies()) {
      <div class="flex flex-col gap-1">
        <label for="pf-currency" class="text-sm font-medium text-gray-700 dark:text-gray-300">
          {{ 'PRODUCTS.FORM.SELL_CURRENCY' | translate }}
        </label>
        <p-select
          inputId="pf-currency"
          [options]="currencySvc.currencyOptions()"
          optionLabel="label"
          optionValue="value"
          [(ngModel)]="form.sellCurrency"
          [disabled]="!!editingId && originalEditQuantity > 0"
          appendTo="body"
          class="w-full"
        />
        @if (!!editingId && originalEditQuantity > 0) {
          <small class="text-xs text-gray-500 dark:text-gray-400">
            {{ 'PRODUCTS.FORM.CURRENCY_LOCKED' | translate }}
          </small>
        }
      </div>

      <!--
        Kelish valyutasi sotuvdan MUSTAQIL: mol `$70` ga kelib so'mda sotilishi mumkin.
        Ikkalasi farq qilsa, foyda uchun kurs kerak — backend uni tizimdan oladi,
        topilmasa xato qaytaradi (kurs taxmin qilinmaydi).
      -->
      <div class="flex flex-col gap-1">
        <label
          for="pf-purchase-currency"
          class="text-sm font-medium text-gray-700 dark:text-gray-300"
        >
          {{ 'PRODUCTS.FORM.PURCHASE_CURRENCY' | translate }}
        </label>
        <p-select
          inputId="pf-purchase-currency"
          [options]="currencySvc.currencyOptions()"
          optionLabel="label"
          optionValue="value"
          [(ngModel)]="form.purchaseCurrency"
          appendTo="body"
          class="w-full"
        />
        @if (form.purchaseCurrency !== form.sellCurrency) {
          <small class="text-xs text-amber-600 dark:text-amber-500">
            {{ 'PRODUCTS.FORM.MIXED_CURRENCY_HINT' | translate }}
          </small>
        }
      </div>
    }

    <!-- Purchase price -->
    <div class="flex flex-col gap-1">
      <label for="pf-purchase" class="text-sm font-medium text-gray-700 dark:text-gray-300">
        {{
          variantMode()
            ? ('PRODUCTS.FORM.BASE_PURCHASE_PRICE' | translate)
            : ('PRODUCTS.FORM.PURCHASE_PRICE' | translate)
        }}
        <span class="text-red-500">*</span>
        <span class="text-gray-400">({{ form.purchaseCurrency }})</span>
      </label>
      <p-inputnumber
        inputId="pf-purchase"
        placeholder="0"
        [min]="0"
        [minFractionDigits]="0"
        [maxFractionDigits]="currencySvc.priceInputDecimals(form.purchaseCurrency)"
        [(ngModel)]="form.purchasePrice"
        (ngModelChange)="onPurchasePriceChange()"
        [useGrouping]="true"
        mode="decimal"
        class="w-full"
      />
    </div>

    <!-- Sell price + Ustama % -->
    <div class="grid grid-cols-1 sm:grid-cols-3 gap-3">
      <div class="sm:col-span-2 flex flex-col gap-1">
        <label for="pf-sell" class="text-sm font-medium text-gray-700 dark:text-gray-300">
          @if (variantMode()) {
            {{ 'PRODUCTS.FORM.BASE_SELL_PRICE' | translate }}
          } @else {
            {{ 'PRODUCTS.FORM.SELL_PRICE' | translate }} <span class="text-red-500">*</span>
          }
          <span class="text-gray-400">({{ form.sellCurrency }})</span>
        </label>
        <p-inputnumber
          inputId="pf-sell"
          placeholder="0"
          [min]="0"
          [minFractionDigits]="0"
          [maxFractionDigits]="currencySvc.priceInputDecimals(form.sellCurrency)"
          [(ngModel)]="form.sellPrice"
          (ngModelChange)="onSellPriceChange()"
          [useGrouping]="true"
          mode="decimal"
          class="w-full"
        />
      </div>
      <div class="flex flex-col gap-1">
        <label for="pf-markup" class="text-sm font-medium text-gray-700 dark:text-gray-300">
          {{ 'PRODUCTS.FORM.MARKUP' | translate }}
        </label>
        <!--
          Valyutalar har xil bo'lsa ustama ma'noga ega emas (dollar xarid, so'm
          sotish) — maydon bloklanadi, aks holda narxni buzib yozardi.
        -->
        <p-inputnumber
          inputId="pf-markup"
          placeholder="0"
          [min]="0"
          [minFractionDigits]="0"
          [maxFractionDigits]="2"
          [disabled]="!profitComparable"
          [(ngModel)]="markupPercent"
          (ngModelChange)="onMarkupChange()"
          suffix="%"
          class="w-full"
        />
      </div>
    </div>

    @if (variantMode()) {
      <div
        class="flex items-start gap-2 text-xs text-indigo-600 dark:text-indigo-400 bg-indigo-50 dark:bg-indigo-900/20 border border-indigo-100 dark:border-indigo-800 rounded-lg px-3 py-2"
      >
        <i class="pi pi-info-circle mt-0.5"></i>
        <span>{{ 'PRODUCTS.FORM.VARIANT_PRICE_HINT' | translate }}</span>
      </div>
    }

    <!-- Discount + Final price -->
    <div class="grid grid-cols-1 sm:grid-cols-3 gap-3 items-end">
      <div class="sm:col-span-2 flex flex-col gap-1">
        <label for="pf-discount" class="text-sm font-medium text-gray-700 dark:text-gray-300">
          {{ 'PRODUCTS.FORM.DISCOUNT' | translate }}
        </label>
        <div class="flex items-center gap-2">
          <!-- Radio: so'm -->
          <label
            for="disc-sum"
            class="flex items-center gap-1 cursor-pointer text-sm text-gray-600 dark:text-gray-400"
          >
            <p-radiobutton
              name="discountType"
              value="sum"
              [(ngModel)]="discountType"
              (ngModelChange)="onDiscountTypeChange()"
              inputId="disc-sum"
            />
            so'm
          </label>
          <!-- Radio: % -->
          <label
            for="disc-pct"
            class="flex items-center gap-1 cursor-pointer text-sm text-gray-600 dark:text-gray-400"
          >
            <p-radiobutton
              name="discountType"
              value="%"
              [(ngModel)]="discountType"
              (ngModelChange)="onDiscountTypeChange()"
              inputId="disc-pct"
            />
            %
          </label>
          <p-inputnumber
            inputId="pf-discount"
            placeholder="0"
            [min]="0"
            [minFractionDigits]="0"
            [maxFractionDigits]="
              discountType === '%' ? 2 : currencySvc.priceInputDecimals(form.sellCurrency)
            "
            [max]="discountType === '%' ? 100 : form.sellPrice"
            [(ngModel)]="discountInput"
            [suffix]="discountType === '%' ? '%' : ''"
            class="flex-1"
          />
        </div>
      </div>
      <!-- Final price display -->
      <div class="flex flex-col gap-1">
        <span class="text-sm font-medium text-green-600 dark:text-green-400">
          {{ 'PRODUCTS.FORM.FINAL_PRICE' | translate }}
        </span>
        <div
          class="h-10 flex items-center px-3 rounded-lg bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800"
        >
          <span class="font-semibold text-green-700 dark:text-green-400 text-sm">
            {{ finalPrice | money: form.sellCurrency }}
          </span>
        </div>
      </div>
    </div>

    <!-- Profit / markup info bar -->
    @if (form.purchasePrice > 0 || discountInput > 0) {
      <div
        class="flex items-center gap-4 text-xs text-gray-500 dark:text-gray-400 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded-lg px-3 py-2"
      >
        @if (profitComparable) {
          <span>
            <i class="pi pi-info-circle mr-1 text-blue-400"></i>
            {{ 'PRODUCTS.FORM.PROFIT' | translate }}:
            <strong
              class="text-gray-700 dark:text-gray-200"
              [class.text-red-600]="(profit ?? 0) < 0"
              [class.dark:text-red-400]="(profit ?? 0) < 0"
              >{{ profit | money: form.sellCurrency }}</strong
            >
          </span>
          <span class="text-gray-300 dark:text-gray-600">|</span>
          <span>
            {{ 'PRODUCTS.FORM.MARKUP_LABEL' | translate }}:
            <strong class="text-gray-700 dark:text-gray-200"
              >{{ markupPercent | number: '1.0-9' }}%</strong
            >
          </span>
        } @else {
          <!-- Ikki valyutani ayirib bo'lmaydi — foyda kurs bilan sotuvda aniqlanadi. -->
          <span>
            <i class="pi pi-info-circle mr-1 text-amber-400"></i>
            {{ 'PRODUCTS.FORM.MIXED_CURRENCY_HINT' | translate }}
          </span>
        }
      </div>
    }

    <!-- Variant rejimi YOKI oddiy miqdor (create only) -->
    @if (!isEdit) {
      <!-- Variant toggle -->
      <div class="flex items-center gap-3 py-1 border-t border-gray-100 dark:border-gray-800 pt-3">
        <p-checkbox
          inputId="pf-variant"
          [ngModel]="variantMode()"
          (ngModelChange)="setVariantMode($event)"
          [binary]="true"
        />
        <label
          for="pf-variant"
          class="text-sm font-medium text-gray-700 dark:text-gray-300 cursor-pointer select-none"
        >
          {{ 'PRODUCTS.VARIANT.TOGGLE' | translate }}
          <span class="text-xs text-gray-400 ms-1">{{
            'PRODUCTS.VARIANT.TOGGLE_HINT' | translate
          }}</span>
        </label>
      </div>

      @if (variantMode()) {
        <!-- Variant xulosasi + o'ng paneini ochish -->
        <div
          class="rounded-lg border border-indigo-100 dark:border-indigo-900/40 bg-indigo-50/40 dark:bg-indigo-900/10 p-3 flex items-center justify-between gap-3"
        >
          <div class="min-w-0">
            <div class="text-sm font-semibold text-gray-700 dark:text-gray-200">
              {{ 'PRODUCTS.VARIANT.SUMMARY_TITLE' | translate }}
            </div>
            <div class="text-xs text-gray-500 dark:text-gray-400 truncate mt-0.5">
              @if (combos().length > 0) {
                {{ combos().length }} {{ 'PRODUCTS.VARIANT.SUMMARY_COUNT' | translate }} ·
                {{ totalVariantQty() }} {{ 'PRODUCTS.VARIANT.SUMMARY_QTY' | translate }}
              } @else {
                {{ 'PRODUCTS.VARIANT.SUMMARY_EMPTY' | translate }}
              }
            </div>
          </div>
          <p-button
            [label]="'PRODUCTS.VARIANT.CONFIGURE' | translate"
            icon="pi pi-sliders-h"
            severity="secondary"
            [outlined]="true"
            size="small"
            (onClick)="variantDrawerVisible = true"
          />
        </div>
      } @else {
        <!-- Oddiy miqdor -->
        <div class="flex flex-col gap-1">
          <label for="pf-qty" class="text-sm font-medium text-gray-700 dark:text-gray-300">{{
            'PRODUCTS.FORM.INITIAL_QTY' | translate
          }}</label>
          <p-inputnumber
            inputId="pf-qty"
            placeholder="0"
            [min]="0"
            [minFractionDigits]="0"
            [maxFractionDigits]="4"
            [(ngModel)]="form.initialQuantity"
            class="w-full"
          />
        </div>
      }

      <!--
        Boshlang'ich qoldiq — faqat OMBOR harakati: kassa, qarz va kirim hujjati
        tegilmaydi. Pulli kirim "Kirim" (Purchases) bo'limidan kiritiladi.
      -->
      @if (form.initialQuantity > 0) {
        <p class="text-xs text-gray-500 dark:text-gray-400 -mt-2">
          {{ 'PRODUCTS.FORM.INITIAL_QTY_NO_MONEY_HINT' | translate }}
        </p>
      }
    } @else if (!editingHasVariants) {
      <!--
        Tahrirdagi qoldiq — TUZATISH (Adjustment), kirim/chiqim emas.
        Analitikaga ta'sir qilmaydi, lekin sabab majburiy (audit uchun).
      -->
      <div class="flex flex-col gap-1">
        <label for="pf-qty" class="text-sm font-medium text-gray-700 dark:text-gray-300">
          {{ 'PRODUCTS.FORM.CURRENT_QTY' | translate }}
        </label>
        <p-inputnumber
          inputId="pf-qty"
          placeholder="0"
          [min]="0"
          [minFractionDigits]="0"
          [maxFractionDigits]="4"
          [(ngModel)]="form.initialQuantity"
          class="w-full"
        />
        <p class="text-xs text-gray-500 dark:text-gray-400">
          {{ 'PRODUCTS.FORM.ADJUST_HINT' | translate }}
        </p>
        @if (editQuantityChanged) {
          <div class="mt-1 flex flex-col gap-1">
            <label
              for="pf-adjust-reason"
              class="text-sm font-medium text-gray-700 dark:text-gray-300"
            >
              {{ 'PRODUCTS.FORM.ADJUST_REASON' | translate }}
              <span class="text-red-500">*</span>
            </label>
            <input
              id="pf-adjust-reason"
              pInputText
              type="text"
              maxlength="500"
              [placeholder]="'PRODUCTS.FORM.ADJUST_REASON_PLACEHOLDER' | translate"
              [(ngModel)]="form.adjustReason"
              class="w-full"
            />
          </div>
        }
      </div>
    }

    <!-- Category -->
    <div class="flex flex-col gap-1">
      <div class="flex items-center justify-between">
        <label for="pf-category" class="text-sm font-medium text-gray-700 dark:text-gray-300">{{
          'PRODUCTS.FORM.CATEGORY' | translate
        }}</label>
        <button
          type="button"
          [disabled]="!isEdit && !formStoreId()"
          (click)="showNewCat = !showNewCat; newCatName = ''"
          class="flex items-center gap-1 text-xs text-green-600 hover:text-green-700 dark:text-green-400 dark:hover:text-green-300 transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
        >
          <i class="pi pi-plus-circle text-xs"></i>
          {{ 'PRODUCTS.FORM.NEW_CATEGORY' | translate }}
        </button>
      </div>
      <p-select
        inputId="pf-category"
        [options]="filteredCategories()"
        optionLabel="name"
        optionValue="id"
        [placeholder]="
          !isEdit && !formStoreId()
            ? ('PRODUCTS.FORM.SELECT_STORE_FIRST' | translate)
            : ('PRODUCTS.FORM.SELECT' | translate)
        "
        [showClear]="true"
        [disabled]="!isEdit && !formStoreId()"
        [ngModel]="form.categoryId"
        (ngModelChange)="onProductCategoryChange($event)"
        appendTo="body"
        class="w-full"
      />
      @if (showNewCat) {
        <div class="flex gap-2 mt-1">
          <input
            pInputText
            [placeholder]="'PRODUCTS.FORM.NEW_CATEGORY_PLACEHOLDER' | translate"
            [(ngModel)]="newCatName"
            (keyup.enter)="createCategoryInline()"
            class="flex-1"
          />
          <p-button
            [label]="'PRODUCTS.FORM.ADD' | translate"
            severity="success"
            size="small"
            [loading]="savingCat()"
            [disabled]="!newCatName.trim()"
            (onClick)="createCategoryInline()"
          />
          <p-button
            [label]="'PRODUCTS.FORM.CANCEL_SHORT' | translate"
            severity="secondary"
            [outlined]="true"
            size="small"
            [disabled]="savingCat()"
            (onClick)="showNewCat = false; newCatName = ''"
          />
        </div>
      }
    </div>

    <!-- Unit of measure -->
    <div class="flex flex-col gap-1">
      <div class="flex items-center justify-between">
        <label for="pf-unit" class="text-sm font-medium text-gray-700 dark:text-gray-300">
          {{ 'PRODUCTS.FORM.UNIT' | translate }} <span class="text-red-500">*</span>
        </label>
        <button
          type="button"
          [disabled]="!isEdit && !formStoreId()"
          (click)="showNewUnit = !showNewUnit; newUnitName = ''"
          class="flex items-center gap-1 text-xs text-green-600 hover:text-green-700 dark:text-green-400 dark:hover:text-green-300 transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
        >
          <i class="pi pi-plus-circle text-xs"></i>
          {{ 'PRODUCTS.FORM.NEW_UNIT' | translate }}
        </button>
      </div>
      <p-select
        inputId="pf-unit"
        [options]="filteredUnits()"
        optionLabel="name"
        optionValue="id"
        [placeholder]="
          !isEdit && !formStoreId()
            ? ('PRODUCTS.FORM.SELECT_STORE_FIRST' | translate)
            : ('PRODUCTS.FORM.SELECT' | translate)
        "
        [disabled]="!isEdit && !formStoreId()"
        [(ngModel)]="form.unitOfMeasureId"
        appendTo="body"
        class="w-full"
      />
      <!--
        `showClear` ATAYLAB yo'q: maydon majburiy bo'lgach, tozalash tugmasi
        foydalanuvchini saqlab bo'lmaydigan holatga olib borardi.
      -->
      @if (showNewUnit) {
        <div class="flex gap-2 mt-1">
          <input
            pInputText
            [placeholder]="'PRODUCTS.FORM.NEW_UNIT_PLACEHOLDER' | translate"
            [(ngModel)]="newUnitName"
            (keyup.enter)="createUnitInline()"
            class="flex-1"
          />
          <p-button
            [label]="'PRODUCTS.FORM.ADD' | translate"
            severity="success"
            size="small"
            [loading]="savingUnit()"
            [disabled]="!newUnitName.trim()"
            (onClick)="createUnitInline()"
          />
          <p-button
            [label]="'PRODUCTS.FORM.CANCEL_SHORT' | translate"
            severity="secondary"
            [outlined]="true"
            size="small"
            [disabled]="savingUnit()"
            (onClick)="showNewUnit = false; newUnitName = ''"
          />
        </div>
      }
    </div>

    <!-- IsWeight toggle -->
    <div class="flex items-center gap-3 py-1">
      <p-checkbox inputId="pf-isweight" [(ngModel)]="form.isWeight" [binary]="true" />
      <label
        for="pf-isweight"
        class="text-sm font-medium text-gray-700 dark:text-gray-300 cursor-pointer select-none"
      >
        {{ 'PRODUCTS.FORM.IS_WEIGHT' | translate }}
        <span class="text-xs text-gray-400 ms-1">{{
          'PRODUCTS.FORM.IS_WEIGHT_HINT' | translate
        }}</span>
      </label>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex items-center gap-2 w-full">
      @if (isEdit) {
        <p-button
          [label]="'VARIANTS_MGR.MANAGE_BTN' | translate"
          icon="pi pi-sitemap"
          severity="secondary"
          [outlined]="true"
          (onClick)="openVariantsManager()"
          [disabled]="saving() || imageUploading()"
        />
      }
      <div class="ml-auto flex gap-2">
        <p-button
          [label]="'PRODUCTS.FORM.CANCEL' | translate"
          severity="secondary"
          [outlined]="true"
          (onClick)="closeDialog()"
          [disabled]="saving() || imageUploading()"
        />
        <p-button
          [label]="
            isEdit ? ('PRODUCTS.FORM.SAVE' | translate) : ('PRODUCTS.FORM.CREATE' | translate)
          "
          icon="pi pi-check"
          (onClick)="save()"
          [loading]="saving() || imageUploading()"
        />
      </div>
    </div>
  </ng-template>
</p-dialog>

<!-- ══ Variant boshqaruvchi (edit rejimida) — o'ng drawer ══ -->
<p-drawer
  [(visible)]="editVariantDrawerVisible"
  position="right"
  [style]="{ width: 'min(48rem, 100vw)' }"
  [header]="'VARIANTS_MGR.TITLE' | translate"
  [dismissible]="true"
  styleClass="variant-drawer"
>
  <div class="space-y-3">
    <p class="text-xs text-gray-500 dark:text-gray-400 -mt-1">
      {{ 'VARIANTS_MGR.DRAWER_HINT' | translate }}
    </p>

    @if (editVariantLoading()) {
      <div class="flex items-center justify-center py-16 text-gray-400">
        <i class="pi pi-spin pi-spinner text-3xl"></i>
      </div>
    } @else {
      <app-variant-builder
        [initialMatrix]="editVariantMatrix()"
        [showQuantity]="true"
        [sellCurrency]="form.sellCurrency"
        [purchaseCurrency]="form.purchaseCurrency"
        (combosChange)="onEditCombosChange($event)"
        (attributeIdsChange)="editAttributeIds = $event"
      />

      <!--
        Mavjud variant qoldig'i o'zgartirilsa — TUZATISH (Adjustment) sifatida
        yoziladi (kirim/chiqim emas), shuning uchun sabab majburiy.
      -->
      @if (variantQuantityChanged) {
        <div class="flex flex-col gap-1 pt-1">
          <label
            for="vf-adjust-reason"
            class="text-sm font-medium text-gray-700 dark:text-gray-300"
          >
            {{ 'PRODUCTS.FORM.ADJUST_REASON' | translate }}
            <span class="text-red-500">*</span>
          </label>
          <input
            id="vf-adjust-reason"
            pInputText
            type="text"
            maxlength="500"
            [placeholder]="'PRODUCTS.FORM.ADJUST_REASON_PLACEHOLDER' | translate"
            [(ngModel)]="variantAdjustReason"
            class="w-full"
          />
          <p class="text-xs text-gray-500 dark:text-gray-400">
            {{ 'PRODUCTS.FORM.ADJUST_HINT' | translate }}
          </p>
        </div>
      }
    }
  </div>

  <ng-template pTemplate="footer">
    <div class="flex items-center justify-end gap-2 w-full">
      <p-button
        [label]="'COMMON.CANCEL' | translate"
        severity="secondary"
        [text]="true"
        (onClick)="editVariantDrawerVisible = false"
        [disabled]="editVariantSaving()"
      />
      <p-button
        [label]="'COMMON.SAVE' | translate"
        icon="pi pi-check"
        [loading]="editVariantSaving()"
        (onClick)="saveEditVariants()"
      />
    </div>
  </ng-template>
</p-drawer>

<!-- ══ Variant qurish paneli (o'ng tomondan chiqadi) ══ -->
<p-drawer
  [(visible)]="variantDrawerVisible"
  position="right"
  [style]="{ width: 'min(44rem, 100vw)' }"
  [header]="'PRODUCTS.VARIANT.DRAWER_TITLE' | translate"
  [dismissible]="true"
  styleClass="variant-drawer"
>
  <div class="space-y-3">
    <p class="text-xs text-gray-500 dark:text-gray-400 -mt-1">
      {{ 'PRODUCTS.VARIANT.DRAWER_HINT' | translate }}
    </p>

    <app-variant-builder
      [storeTypeId]="formStoreTypeId()"
      [showQuantity]="true"
      [sellCurrency]="form.sellCurrency"
      [purchaseCurrency]="form.purchaseCurrency"
      (combosChange)="onCombosChange($event)"
    />
  </div>

  <ng-template pTemplate="footer">
    <div class="flex items-center justify-between gap-3 w-full">
      <span class="text-xs text-gray-500 dark:text-gray-400">
        @if (combos().length > 0) {
          {{ combos().length }} {{ 'PRODUCTS.VARIANT.SUMMARY_COUNT' | translate }} ·
          {{ totalVariantQty() }} {{ 'PRODUCTS.VARIANT.SUMMARY_QTY' | translate }}
        }
      </span>
      <p-button
        [label]="'PRODUCTS.VARIANT.DONE' | translate"
        icon="pi pi-check"
        (onClick)="variantDrawerVisible = false"
      />
    </div>
  </ng-template>
</p-drawer>
